(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name TrabgradoController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('TrabgradoController', TrabgradoController);

    TrabgradoController.$inject = ["trabgradoService","$window","$timeout","$location"];

    function TrabgradoController(trabgradoService,$window,$timeout,$location)
    {
    	var vm = this;
        vm.service = trabgradoService;
        vm.data = {};
        vm.data.etiquetas = {};
        vm.loading = false;
        vm.items=[];
        vm.offset=0;
        vm.loading_images = false;
        vm.loading_files = false;
        vm.option = 'id desc';

        vm.orden = { ordenparam : true, nombre:'year' };

        vm.cambiarOrden = function(nombre){
            if(nombre==vm.orden.nombre){
                //console.log("IGUAL");
                //console.log("IGUAL");
                if(vm.orden.ordenparam == false){
                    vm.orden.ordenparam = true;
                }else{
                    vm.orden.ordenparam = false;
                }
            }else{
                vm.orden.ordenparam = false;
            }
            vm.orden.nombre = nombre;
            //vm.orden.fin_nombre = vm.orden.ordenparam+nombre;
            //console.log(vm.orden);
        }


        vm.init = function(grupo_ids)
        {
            if(vm.loading)
                return;

            vm.loading = true;

            vm.service.getTrabgrado(grupo_ids,vm.offset,vm.option).then(function(data)
            {
                vm.data = data.items;
                vm.loading =false;
                if(data.items.length){
                    vm.offset++;    
                    vm.items = vm.items.concat(data.items);
                }
                setTimeout(function(){ 
                    console.log('a');
                    $('.table-orders .collapse').on('shown.bs.collapse', function () {
                      var $scrollEl = $(this).closest('.card');
                      var $scrollWTo = $scrollEl.offset().top;
                      $('body, html').animate({ scrollTop: $scrollWTo - 80 }, 500);
                    });
                }, 100);
            });
        };

    }


})();